// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3QRp5","options":"AnswerScale_options__OWd3F","selected":"AnswerScale_selected__29M2D"};